/**
 * LeftShield Admin - API Setup Hook
 *
 * Initializes the API service with the authentication token provider.
 */
import { useEffect, useRef } from 'react';
import { useAuth } from '../features/authentication';
import { setTokenProvider } from '../services/api';

/**
 * Hook to initialize the API service with authentication.
 * Call this once in the authenticated app root.
 */
export function useApiSetup(): void {
  const { getAccessToken } = useAuth();
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      setTokenProvider(getAccessToken);
      initialized.current = true;
    }
  }, [getAccessToken]);
}

export default useApiSetup;
